import { createContext, useContext } from 'react';
import type { AuthState } from '../api/request';
import type { AttendancePolicyResponse, MeResponse, WorkLocationResponse } from '../api/types';

/**
 * Konteks sesi — identitas, kebijakan aktif, dan lokasi kerja.
 *
 * Dimuat sekali di batas autentikasi, bukan di tiap halaman. Kebijakan absensi menentukan
 * hampir seluruh perilaku layar check-in (ambang akurasi, wajib selfie, boleh di luar radius),
 * jadi memuatnya per halaman akan membuat layar berkedip antara dua aturan berbeda.
 */
export interface WorkforceSession {
  readonly auth: AuthState;
  readonly me: MeResponse;
  /** `null` bila organisasi belum mengaktifkan kebijakan absensi (server menolak ATT-001). */
  readonly policy: AttendancePolicyResponse | null;
  readonly workLocations: readonly WorkLocationResponse[];
  readonly reload: () => void;
  /**
   * Dipanggil dari mana pun — ADA KARENA tombol Keluar pindah dari header ke halaman Lainnya
   * (item 12, review 12 Sep 2026), dan halaman itu tidak menerimanya lewat prop seperti `AppShell`.
   */
  readonly onSignOut: () => void;
}

export const WorkforceContext = createContext<WorkforceSession | null>(null);

export function useSession(): WorkforceSession {
  const session = useContext(WorkforceContext);
  if (!session) {
    throw new Error('useSession dipakai di luar WorkforceContext');
  }
  return session;
}
